module.exports = __webpack_public_path__ + "static/media/Overview_selected.849a0a9f.svg";